<template>
  <div class="header" v-if="project">
    <div class="row">
      <router-link to="/work" class="col-6 col-3-md header__back fw-500 c-light-grey" @mouseenter.native="activeArrow = true" @mouseleave.native="activeArrow = false" tag="div">
        <arrow size="large" :active="activeArrow"></arrow>
      </router-link>
    </div>
    <div class="row description">
      <div class="col-12 col-10-md left-2-md">
        <h1 class="header__heading">{{ project.title }}</h1>
      </div>
      <div class="col-12 col-2-md">
        <a v-if="project.url" class="description__website" :href="`https://${project.url}`" target="_blank">Visit website</a>
      </div>
      <div class="col-12 col-8-md description__body">
        <div v-html="project.description"></div>
      </div>
      <div v-if="project.awards" class="col-6 col-4-md left-2-md awards">
        <span>Awards</span>
        <ul class="awards__list">
          <li v-for="award in project.awards" class="awards__item" :key="award">{{ award }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Arrow from '../Arrow.vue'

export default {
  name: 'project-header',
  props: ['project'],
  data () {
    return {
      activeArrow: false
    }
  },
  components: {
    Arrow
  }
}
</script>

<style lang="sass">

@import "../../assets/sass/utilities/variables"
@import "../../assets/sass/utilities/mixins"

.header
  font-size: 14px
  margin-bottom: 40px
  +medium
    margin-bottom: 120px
    font-size: 16px
  & .row
    width: 100%

.header__heading
  font-size: 1.5rem
  text-align: left
  margin: 0
  line-height: 1
  margin-bottom: 40px
  +small
    font-size: 2rem
  +medium
    padding-left: 12px
    font-size: 3rem

.header__subheading
  font-size: 1.5em
  font-weight: 500

.header__back
  opacity: 1
  transition: opacity 500ms
  margin-top: 4.5vw
  display: block
  cursor: pointer
  +small
    margin-top: 4.5vw
  +medium
    display: inline-block
    margin-top: 4.5vw
  img
    width: 100%

.description
  margin-top: 50px
  font-weight: 500
  display: flex
  flex-direction: column
  +medium
    flex-direction: row
    margin-top: 75px

.description__body
  color: black
  font-size: 0.85em
  line-height: 1.4
  margin: 0
  margin-bottom: 20px
  +small
    column-count: 2
    column-gap: 24px
  & > div > p
    margin-top: 0

.description__website
  font-size: 0.8rem
  display: inline-block
  border-bottom: 1px solid black
  +medium(max)
    margin-bottom: 10px

.awards
  font-size: 0.8rem
  margin-top: 1em

.awards__list
  padding-top: 0.3em
  list-style-type: none
  margin-top: 0
  padding-left: 0
  line-height: 1.45
  +medium
    column-count: 2

.awards__item
  color: $light-grey

</style>



// WEBPACK FOOTER //
// Header.vue?27fc8edc